export default __webpack_public_path__ + "static/media/lastMinute_thumbnail.77346039.png";